import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

export const useHealthlinkVaccines = () => {

  const tenantVal =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: ["healthlinkVaccines", tenantVal],
    queryFn: async () => {
      if (!tenantVal) return [];

      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.get(
        `${tenantVal}/vaccine-codes/all`
      );

      if (response && response.data) {
        const filtered = response.data.filter(
          (v) => v.active && !v.deleted && !v.disabled
        );
        return filtered;
      }
      return [];
    },
    enabled: !!tenantVal,
    meta: { errorMessage: "Error fetching vaccines" },
  });
};
